import { render, staticRenderFns } from "./NewChatContacts.vue?vue&type=template&id=0237ce51&scoped=true&"
import script from "./NewChatContacts.vue?vue&type=script&lang=js&"
export * from "./NewChatContacts.vue?vue&type=script&lang=js&"
import style0 from "./NewChatContacts.vue?vue&type=style&index=0&id=0237ce51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237ce51",
  null
  
)

export default component.exports